import { render } from "./BeritaAcara.vue?vue&type=template&id=3cb88e8a&scoped=true"
import script from "./BeritaAcara.vue?vue&type=script&lang=js"
export * from "./BeritaAcara.vue?vue&type=script&lang=js"

import "./BeritaAcara.vue?vue&type=style&index=0&id=3cb88e8a&lang=css&scoped=true"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb88e8a"]])

export default __exports__